import { useCallback, useState } from 'react'
import { useSelectedStatesActionsContext } from 'pages/AbsencePlanner/contexts/selectedStatesContext'
import useNewAbsenceRequest from 'pages/Tasks/AbsenceRequest/New/useNewAbsenceRequest'
import type { CreateAbsenceRequestResultT } from 'types'
import { SIDE_MENU_OPTIONS } from '../../SideMenu/constants'
import type { UseSideMenuNewAbsenceRequestProps } from './types'

export const useSideMenuNewAbsenceRequest = ({ setPage, onRefresh }: UseSideMenuNewAbsenceRequestProps) => {
  const [isBalancesDrawerOpen, setIsBalanceDrawerOpen] = useState(false)
  const { setSelectedTaskUuid } = useSelectedStatesActionsContext()

  const onSubmitComplete = useCallback(
    (result: CreateAbsenceRequestResultT) => {
      setPage(SIDE_MENU_OPTIONS.personalAbsences)
      setSelectedTaskUuid(result.createAbsence.taskUuid)
      onRefresh?.()
    },
    [onRefresh, setPage, setSelectedTaskUuid],
  )

  const absenceRequestProps = useNewAbsenceRequest(onSubmitComplete)
  const {
    formFields: {
      personUuid: { value: personUuid },
    },
  } = absenceRequestProps

  return {
    ...absenceRequestProps,
    isBalancesDrawerOpen,
    setIsBalanceDrawerOpen,
    personUuid,
  }
}
